import React from 'react';

import Image from 'common/components/Placeholder/components/Image/Image';
import TextBlock from 'common/components/Placeholder/components/TextBlock/TextBlock';

import styles from './ArticleBig.module.scss';

const ArticleBig = () => (
  <div className={styles.ArticleBig}>
    <Image color={styles.PlaceholderDefaultColor} className={styles.ImageBig} />
    <div className={styles.WhiteBox}>
      <TextBlock
        rows={3}
        color={styles.PlaceholderDefaultColor}
        className={styles.TextBlock}
      />
    </div>
  </div>
);

export default ArticleBig;



// WEBPACK FOOTER //
// ./src/common/components/Placeholder/components/ArticleBig/ArticleBig.js